import { websiteBuilderZLayers } from "pages/secure/facility/websiteBuilder/editor/websiteBuilderZLayers";
import React, { useMemo } from "react";

export type TElementViewResizeHandle =
  | "NorthWest"
  | "North"
  | "NorthEast"
  | "West"
  | "East"
  | "SouthWest"
  | "South"
  | "SouthEast";

export type TElementViewResizeHandlePointerDown = (e: React.PointerEvent, handle: TElementViewResizeHandle) => void;

interface IElementViewResizeHandleProps {
  handle: TElementViewResizeHandle;
  viewWidth: number;
  viewHeight: number;
  onPointerDown: TElementViewResizeHandlePointerDown;
}

export function ElementViewResizeHandle(props: IElementViewResizeHandleProps) {
  const { handle, viewWidth, viewHeight, onPointerDown } = props;

  const style: React.CSSProperties = useMemo(() => {
    const HANDLE_SIZE = 6;
    const HALF_HANDLE_SIZE = HANDLE_SIZE / 2;

    const defaultStyles: React.CSSProperties = {
      zIndex: websiteBuilderZLayers.designSpace.elementOverride,
      width: HANDLE_SIZE,
      height: HANDLE_SIZE,
    };

    switch (handle) {
      case "NorthWest":
        return {
          ...defaultStyles,
          left: -HALF_HANDLE_SIZE,
          top: -HALF_HANDLE_SIZE,
          cursor: "nwse-resize",
        };
      case "North":
        return {
          ...defaultStyles,
          left: viewWidth / 2 - HALF_HANDLE_SIZE,
          top: -HALF_HANDLE_SIZE,
          cursor: "ns-resize",
        };
      case "NorthEast":
        return {
          ...defaultStyles,
          left: viewWidth - HALF_HANDLE_SIZE,
          top: -HALF_HANDLE_SIZE,
          cursor: "nesw-resize",
        };
      case "West":
        return {
          ...defaultStyles,
          left: -HALF_HANDLE_SIZE,
          top: viewHeight / 2 - HALF_HANDLE_SIZE,
          cursor: "ew-resize",
        };
      case "East":
        return {
          ...defaultStyles,
          left: viewWidth - HALF_HANDLE_SIZE,
          top: viewHeight / 2 - HALF_HANDLE_SIZE,
          cursor: "ew-resize",
        };
      case "SouthWest":
        return {
          ...defaultStyles,
          left: -HALF_HANDLE_SIZE,
          top: viewHeight - HALF_HANDLE_SIZE,
          cursor: "nesw-resize",
        };
      case "South":
        return {
          ...defaultStyles,
          left: viewWidth / 2 - HALF_HANDLE_SIZE,
          top: viewHeight - HALF_HANDLE_SIZE,
          cursor: "ns-resize",
        };
      case "SouthEast":
        return {
          ...defaultStyles,
          left: viewWidth - HALF_HANDLE_SIZE,
          top: viewHeight - HALF_HANDLE_SIZE,
          cursor: "nwse-resize",
        };
      default:
        return {};
    }
  }, [handle, viewWidth, viewHeight]);

  return (
    <div
      className="website-builder-element-view-resize-handle"
      style={style}
      onPointerDown={e => onPointerDown(e, handle)}
    />
  );
}
